import CardMembershipIcon from '@mui/icons-material/CardMembership'
import DescriptionIcon from '@mui/icons-material/Description'
import GroupsIcon from '@mui/icons-material/Groups'
import HowToRegIcon from '@mui/icons-material/HowToReg'
import InsightsIcon from '@mui/icons-material/Insights'
import DashboardIcon from '@/components/Svg/school/menu/dashboard';
import LaboratoriesIcon from '@/components/Svg/school/menu/laboratories';
import TeamIcon from '@/components/Svg/school/menu/team';
import ViewIcon from '@/components/Svg/school/menu/view';
import { EntityList } from "@/types/Entity";
import { CONSTANTS } from "@/types/enum/constants";
import { CountryEnum } from "@/types/enum/enumUser";

const getIndustryOfficeSchoolIndustry = [
  {
    route: "Dashboard",
    text: "Tableau de bord",
    t: "routes.backoffice.school.industry.dashboard",
    icon: DashboardIcon,
    href: "/industryoffice/school/dashboard-industry",
    menuHeader: true,
    position: 10
  },
  {
    route: "MyTrainings",
    text: "Mes formations",
    mobileText: "Formations",
    t: "routes.backoffice.school.industry.myTrainings",
    href: "/backoffice/school/my-trainings",
    icon: LaboratoriesIcon,
    menuHeader: true,
    position: 20,
    fnBadge: ({ dataMyProfile }) =>
      !!dataMyProfile?.counterTaskEntityForMenu
        ? JSON.parse(dataMyProfile?.counterTaskEntityForMenu)?.nbTrainings
        : 0
  },
  {
    route: "TrainingEdit",
    text: "Edition d'une formation",
    t: "routes.backoffice.school.industry.trainingEdit",
    href: "/industryoffice/school/trainings/[trainingId]"
  },
  {
    route: "MyListTargets",
    text: "Mes listes clients",
    t: "routes.backoffice.school.industry.myListTargets",
    href: "/industryoffice/group/my-list-targets",
    menuHeader: true,
    icon: TeamIcon,
    position: 30
  },
  {
    route: "ListIndustriesSchool",
    text: "Aperçu de mes formations",
    mobileText: "Aperçu formations",
    t: "routes.backoffice.school.industry.viewMyTrainings",
    href: "/industryoffice/school/view-my-trainings",
    menuHeader: true,
    icon: ViewIcon,
    position: 40
  },
  {
    // France et Belgique dans un module ouvert à plusieurs pays (cf. country-scope-front.md), sauf
    // pour un laboratoire dont la fiche ferme la page (onglet « Gestion School »).
    route: "SchoolAnalytics",
    text: "Analyse des formations",
    t: "routes.backoffice.school.analytics",
    href: "/industryoffice/school/analytics",
    icon: InsightsIcon,
    menuHeader: true,
    position: 45,
    fnDisplay: ({ dataMyProfile }) =>
      [CountryEnum.FRANCE, CountryEnum.BELGIUM].includes(
        dataMyProfile?.selectCompanyDefault?.country?.toUpperCase()
      ) && dataMyProfile?.selectCompanyDefault?.schoolAnalyticsEnabled === true
  },
  {
    route: "Participants",
    text: "Les participants",
    t: "routes.backoffice.school.industry.participants",
    href: "/backoffice/school/participants",
    icon: GroupsIcon,
    menuHeader: true,
    position: 50
  },
  {
    route: "AskAccessRequests",
    text: "Demandes d'accès",
    t: "routes.backoffice.school.industry.askAccess",
    href: "/industryoffice/school/ask-access",
    icon: HowToRegIcon,
    menuHeader: true,
    position: 55,
    fnBadge: ({ dataMyProfile }) =>
      !!dataMyProfile?.counterTaskEntityForMenu
        ? JSON.parse(dataMyProfile?.counterTaskEntityForMenu)?.nbSchoolAskRequestsPending
        : 0
  },
  {
    route: "MyContract",
    text: "Mon contrat",
    t: "routes.backoffice.school.industry.myContract",
    href: "/industryoffice/school/my-contract",
    icon: DescriptionIcon,
    menuHeader: true,
    position: 70,
    fnDisplay: ({ dataMyProfile }) => {
      return [CountryEnum.FRANCE].includes(
        dataMyProfile?.selectCompanyDefault?.country?.toUpperCase()
      );
    }
  }, {
    route: "ViewMySubscriptions",
    text: "Mon abonnement",
    t: "routes.backoffice.school.industry.mySubscription",
    href: "/industryoffice/school/my-subscription",
    icon: CardMembershipIcon,
    menuHeader: true,
    position: 60
  },
  {
    route: "TrainingEdit",
    text: "Editer une formation",
    t: "routes.backoffice.school.industry.editTraining",
    href: "/industryoffice/school/training/[trainingId]"
  },

  {
    route: "TrainingDescription",
    href: "/industryoffice/school/training-description/[id]",
    menuHeader: false
  },
  {
    route: "MyProfile",
    text: "Mon profil",
    t: "routes.backoffice.school.industry.myProfile",
    href: "/backoffice/common/my-profile",
    menuHeader: false
  }
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISCHOOL],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_INDUSTRY_MANAGER]
}));

export default getIndustryOfficeSchoolIndustry;
